// Case státuszok — backend értékek, i18n kulcsok, chip-osztályok
export const CASE_STATUSES = [
  'awaiting_assignment', 'waiting_for_agent', 'waiting_for_client',
  'resolved', 'closed',
];

export const statusKey = (s) => `caseStatus.${s}`;
export const statusChip = (s) => `cs-chip cs-${(s || '').replace(/_/g, '-')}`;

// Agent által kézzel felülbírálható státuszok (dropdown)
export const AGENT_SETTABLE = ['waiting_for_agent', 'waiting_for_client'];
